import { ValidationRuleTriggers } from "./triggers";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { localize } from "client_legacy/ndaw/culture";

class HasMinimumEntriesRule<TCollection extends ReadonlyArray<unknown>> extends ValidationRuleTriggers<TCollection> {
	private readonly _minimumAmount: number;
	private readonly _alternativeMessage: string | undefined;

	constructor(minimumAmount: number, alternativeMessage?: string) {
		super();
		this._alternativeMessage = alternativeMessage;
		this._minimumAmount = minimumAmount;
	}

	public validate(value: ReadonlyArray<unknown>): InputValidationResult {
		if (!value || value.length >= this._minimumAmount) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: (this._alternativeMessage || localize("_MinCountRequired")).replace("{{Number}}", this._minimumAmount.toString())
		};
	}
}

class HasMaximumEntriesRule<TCollection extends ReadonlyArray<unknown>> extends ValidationRuleTriggers<TCollection> {
	private readonly _maxAmount: number;
	private readonly _alternativeMessage: string | undefined;

	constructor(maxAmount: number, alternativeMessage?: string) {
		super();
		this._alternativeMessage = alternativeMessage;
		this._maxAmount = maxAmount;
	}

	public validate(value: ReadonlyArray<unknown>): InputValidationResult {
		if (!value || value.length <= this._maxAmount) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: (this._alternativeMessage || localize("_MaxCountRequired")).replace("{0}", this._maxAmount.toString())
		};
	}
}

export {
	HasMinimumEntriesRule,
	HasMaximumEntriesRule
};